export default __webpack_public_path__ + "static/media/soyl_holiday_social_3.375fd942.jpg";